module.exports = __webpack_public_path__ + "static/media/k400at8000079copy.cb82c83f.jpg";